import React from 'react';
export var I18nContext = /*#__PURE__*/React.createContext(null);
export var I18nIdsContext = /*#__PURE__*/React.createContext([]);
export var I18nParentContext = /*#__PURE__*/React.createContext(null);